module.exports = __webpack_public_path__ + "f34c3b2849540a1e56efb24f625a9c45.jpg";